import React from 'react';

// Standardized Change Logs — shared design across the AGS Astra suite.
// Date-wise releases, each with type (New / Update / Bugfix) tags.
const CHANGE_LOG_DATA = [
  {
    version: 'V1.2.0',
    date: 'Jun 2026',
    sections: [
      {
        type: 'New',
        title: 'Unified AGS Astra look',
        items: [
          'Standardized sidebar, header, dark mode, Change Logs, App Guide, and the assistant button to match the rest of the AGS Astra suite.',
          'Added a floating AI Assistant that answers questions about the loaded inverter data.'
        ]
      },
      {
        type: 'Update',
        title: 'Navigation & theme',
        items: [
          'Sidebar widened to the standard 224px (80px collapsed) with the suite-green active state.',
          'Header raised to the standard 96px green bar with title and subtitle.',
          'Dark mode now persists between sessions.'
        ]
      }
    ]
  },
  {
    version: 'V1.1.0',
    date: 'May 2026',
    sections: [
      {
        type: 'New',
        title: 'Multi-site & history',
        items: [
          'Multi-site inverter analysis with per-site health ratios.',
          'Upload History — revisit the last 10 uploaded analyses without re-processing.'
        ]
      },
      {
        type: 'Update',
        title: 'Performance',
        items: [
          'Overview loads a lightweight summary first for fast first paint on large uploads, then loads full data on demand.'
        ]
      }
    ]
  },
  {
    version: 'V1.0.0',
    date: 'Apr 2026',
    sections: [
      {
        type: 'New',
        title: 'VoltIQ launch',
        items: [
          'Inverter health dashboard with hourly performance analysis.',
          'Excel upload pipeline and health-ratio scoring across sites.',
          'SSO sign-in from the AGS Astra suite.'
        ]
      }
    ]
  }
];

const TAG_STYLES_LIGHT = {
  New: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/30',
  Update: 'bg-blue-500/15 text-blue-700 border-blue-500/30',
  Bugfix: 'bg-amber-500/15 text-amber-700 border-amber-500/30'
};
const TAG_STYLES_DARK = {
  New: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  Update: 'bg-blue-500/15 text-blue-300 border-blue-500/30',
  Bugfix: 'bg-amber-500/15 text-amber-300 border-amber-500/30'
};

const ChangeLogs = ({ darkMode = false }) => {
  const tagStyles = darkMode ? TAG_STYLES_DARK : TAG_STYLES_LIGHT;
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className={`text-2xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Change Logs</h1>

      {CHANGE_LOG_DATA.map((release) => (
        <div key={release.version + release.date} className="mb-10">
          <div className="flex items-baseline gap-3 mb-4">
            <span className={`text-lg font-semibold ${darkMode ? 'text-gray-100' : 'text-gray-800'}`}>{release.version}</span>
            <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>{release.date}</span>
          </div>

          <div className="space-y-6">
            {release.sections.map((section, idx) => (
              <div key={idx} className={`border rounded-lg p-4 shadow-sm ${darkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-white'}`}>
                <span
                  className={`inline-block px-3 py-1 rounded-full text-xs font-semibold border ${tagStyles[section.type] || 'bg-gray-100 text-gray-700'}`}
                >
                  {section.type}
                </span>
                <h3 className={`mt-3 font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{section.title}</h3>
                <ul className={`mt-2 list-disc list-inside space-y-1 text-sm ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  {section.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChangeLogs;
